export default __webpack_public_path__ + "static/media/lifestrike.3b7f80c9.png";